module.exports = "/_next/static/files/d9ecde0edd713fdba0f67576d7f08d5e.svg";